import * as React from "react";
import { View, Image, ScrollView, Dimensions, StyleSheet } from "react-native";
import PDFReader from "rn-pdf-reader-js";
import CustomHeader from "../../components/CustomHeader";
import CloseIcon from "../../components/icons/CloseIcon";
import CachedImage from "react-native-expo-cached-image";
import { WebView } from "react-native-webview";

const { height, width } = Dimensions.get("window");

const ViewPOIDocument = ({ route }) => {
  const { ext, url } = route?.params || {};
  return (
    <View style={styles.container}>
      <CustomHeader title="View Document" leftIcon={<CloseIcon />} />

      {ext === "pdf" ? (
        <WebView source={{ uri: url }} />
      ) : (
        <ScrollView contentContainerStyle={styles.contentContainerStyle}>
          <Image source={{ uri: url }} style={styles.image} />
        </ScrollView>
      )}
    </View>
  );
};

export default ViewPOIDocument;

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: "white" },
  contentContainerStyle: { flexGrow: 0, paddingBottom: 10 },
  image: {
    width: width,
    height: height,
    alignSelf: "center",
    resizeMode: "contain",
  },
});
